import toast from "react-hot-toast"

export const loadingToast = (message?: string) => toast.loading(message || "", { id: "loading" })
